import { Component, Inject, Input, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import moment from 'moment';
import { NGXLogger } from 'ngx-logger';
import { BehaviorSubject, ReplaySubject } from 'rxjs';
import { ILedger } from 'src/app/accounts/ledger/ledger.interface';
import { IBusinessSegment } from '../../business-segment/business-segment.interface';

@Component({
    selector: 'app-gst-update-form',
    templateUrl: './gst-update-form.component.html',
    styleUrls: ['./gst-update-form.component.less'],
    standalone: false
})
export class GstUpdateFormComponent implements OnInit {

  constructor(private formBuilder:FormBuilder,private dailogRef:MatDialogRef<GstUpdateFormComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any,private logger:NGXLogger) {
                  this.dailogRef.disableClose=true;
                  this.gstDetailColumns=this.data?.name==='SEZ INCOME'?['gstWef','gstWet','igst','action']:
                            ['gstWef','gstWet','sgst','cgst','igst','action'];
               }

  @Input() searching: boolean = false;
  filteredSegments:ReplaySubject<IBusinessSegment[]> = new ReplaySubject<IBusinessSegment[]>(1);
  segmentSearchCtrl = this.formBuilder.control('');
  filteredStates:ReplaySubject<IBusinessSegment[]> = new ReplaySubject<IBusinessSegment[]>(1);
  stateSearchCtrl = this.formBuilder.control('');
  filteredLedgers:ReplaySubject<ILedger[]> = new ReplaySubject<ILedger[]>(1);
  ledgerSearchCtrl = this.formBuilder.control('');
  filteredCharges:ReplaySubject<ILedger[]> = new ReplaySubject<ILedger[]>(1);
  chargeSearchCtrl = this.formBuilder.control('');
  filteredSacCharges:ReplaySubject<ILedger[]> = new ReplaySubject<ILedger[]>(1);
  sacSearchCtrl = this.formBuilder.control('');
  gstDetailsDatasource=new BehaviorSubject<AbstractControl[]>([]);
  gstDetailColumns=['gstWef','gstWet','sgst','cgst','igst','action'];
  gstUpdateForm:FormGroup;
  taxableList:any;
  chargeTypeList:any;
  dataToPatch:any;
  name:string;
  ngOnInit(): void {
    this.initializeForm();
    this.dataToPatch=this.data?.chargeDetails;
    this.name=this.data?.name;
    if(this.dataToPatch){
      this.patchGstDetails();
    }
  }

  private patchGstDetails(){
    this.gstDetails.clear();
    this.dataToPatch.forEach(element => {
      if(this.name==='SEZ INCOME'){
        this.gstDetails.push(this.sezGstDetailForm(element));
      } else {
        this.gstDetails.push(this.gstDetailForm(element));
      }
    }); 
    this.gstDetailsDatasource.next(this.gstDetails.controls);
  }

  private initializeForm(){
    this.gstUpdateForm=this.formBuilder.group({
      gstDetails:this.formBuilder.array([this.gstDetailForm()]),
    })
    this.gstDetailsDatasource.next(this.gstDetails.controls);
  }

  private sezGstDetailForm(data?:any): FormGroup {
    return this.formBuilder.group({
      id:[data?data.id:null],
      gstWef:[data?data.gstWef:null,[Validators.required]],
      chargeId:[data?data.chargeId:null,[Validators.required]],
      taxable:[data?data.taxable:null,[Validators.required]],
      chargeTypeMechanism:[data?data.chargeTypeMechanism:null,[Validators.required]],
      sacId:[data?data.sacId:null,[Validators.required]],
      gstWet:[data?data.gstWet:null],
      igst:[data?data.igst:null,[Validators.required,Validators.pattern('^[0-9.]*$')]],
      activeDetail:[data?data.activeDetail:true],
      show:[data?data.show:true],
    })
  }

  private gstDetailForm(data?:any): FormGroup {
    return this.formBuilder.group({
      id:[data?data.id:null],
      gstWef:[data?data.gstWef:null,[Validators.required]],
      chargeId:[data?data.chargeId:null,[Validators.required]],
      taxable:[data?data.taxable:null,[Validators.required]],
      chargeTypeMechanism:[data?data.chargeTypeMechanism:null,[Validators.required]],
      sacId:[data?data.sacId:null,[Validators.required]],
      gstWet:[data?data.gstWet:null],
      sgst:[data?data.sgst:null,[Validators.required,Validators.pattern('^[0-9.]*$')]],
      cgst:[data?data.cgst:null,[Validators.required,Validators.pattern('^[0-9.]*$')]],
      igst:[data?data.igst:null,[Validators.required,Validators.pattern('^[0-9.]*$')]],
      activeDetail:[data?data.activeDetail:true],
      show:[data?data.show:true],
    })
  }

  removeGstDetailField(index:number){
    if(index-1>=0){
      this.gstDetails.at(index-1).get('gstWet').reset();
    }
    this.gstDetails.removeAt(index);
    this.gstDetailsDatasource.next(this.gstDetails.controls);
  }

  addGstDetailField(item?:any){
    item.get('gstWet').setValidators([Validators.required]);
    item.get('gstWet').updateValueAndValidity();
    if(item.invalid){
      item.markAllAsTouched();
      return;
    }
    item.get('activeDetail').setValue(false);
    let newFormToPush = this.modifyPreviousDetails(item.value);  
    this.gstDetails.push(newFormToPush);
    this.gstDetailsDatasource.next(this.gstDetails.controls);
  }

  private modifyPreviousDetails(item: any) {
    let newFormToPush=this.name==='SEZ INCOME'?this.sezGstDetailForm():this.gstDetailForm();
    newFormToPush.get('gstWef').setValue(moment(item.gstWet, "YYYY-MM-DD").add(1, 'days').toDate());
    newFormToPush.get('sacId').setValue(item.sacId);
    newFormToPush.get('chargeId').setValue(item.chargeId);
    newFormToPush.get('activeDetail').setValue(true);
    newFormToPush.get('show').setValue(false);
    newFormToPush.get('chargeTypeMechanism').setValue(item.chargeTypeMechanism);
    newFormToPush.get('taxable').setValue(item.taxable);
    return newFormToPush;
  }

  dateChangeEvent(event:any,item:any,formControlName:any){
    let formattedDate=moment(event.value).utc(true).toDate();
    if(formControlName==='gstWet'){
      item.get('gstWet').setValue(formattedDate);
      item.get('activeDetail').setValue(false);
      if(this.gstDetails.length<=this.dataToPatch.length){
        let newFormToPush = this.modifyPreviousDetails(item.value);  
        this.gstDetails.push(newFormToPush);
        this.gstDetailsDatasource.next(this.gstDetails.controls);
      }
    } else {
      item.get('gstWef').setValue(formattedDate);
    }
  }

  onSave(){
    if(this.gstUpdateForm.invalid){
      this.gstUpdateForm.markAllAsTouched();
      return;
    }
    this.dailogRef.close(this.gstDetails.value);
  }

  onCancel(){
    this.dailogRef.close(false);
  }

  get id(){ return this.gstUpdateForm.get('id'); }
  get stateId(){ return this.gstUpdateForm.get('stateId'); }
  get segmentId(){ return this.gstUpdateForm.get('segmentId'); }
  get ledgerId(){ return this.gstUpdateForm.get('ledgerId'); }
  get chargeId(){ return this.gstUpdateForm.get('chargeId'); }
  get chargeName(){ return this.gstUpdateForm.get('chargeName'); }
  get chargeTypeMechanism(){ return this.gstUpdateForm.get('chargeTypeMechanism'); }
  get taxable(){ return this.gstUpdateForm.get('taxable'); }
  get sacId(){ return this.gstUpdateForm.get('sacId'); }
  get sacName(){ return this.gstUpdateForm.get('sacName'); }
  get message(){ return this.gstUpdateForm.get('message'); }
  get gstDetails(){ return <FormArray>this.gstUpdateForm.get('gstDetails'); }
}
